import * as yup from 'yup';

export const createSchema = (data: Record<string, any[]>) => {
  return yup.object().shape(
    Object.keys(data).reduce((acc, section) => {
      data[section].forEach((item, index) => {
        acc[`${item.raterID}`] = yup
          .string()
          .required('This field is required');
      });
      return acc;
    }, {})
  );
};